import { StorageKeyConstants } from '@tfagency/shared/util';

export class PortalStorageKeyConstants extends StorageKeyConstants {
  static readonly STB_PROPERTIES_QUERY = 'stb_properties_query';
  static readonly LEADS_QUERY = 'leads_query';
  static readonly NEWS_FEED_QUERY = 'news_feed_query';
  static readonly BROKER_FULL_NAME_FILTER = 'broker_full_name_filter';
  static readonly IS_MENU_COLLAPSED = 'is_menu_collapsed';
}
